/**
 * Runtime Environment Variables
 *
 * For S3 deployments - values computed at runtime based on domain.
 * Based on: recruiter-ui/app/runtimeEnvVars.js
 */

import { domainMeta } from '@/utils/domain-meta';

export const WX_NAVBAR_VERSION =
  import.meta.env.VITE_WX_NAVBAR_VERSION ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const WX_COPILOT_VERSION =
  import.meta.env.VITE_WX_COPILOT_VERSION ??
  (domainMeta.environment === 'prod' ? 'stable' : 'main');

export const I18N_LOG_MISSING_TRANSLATIONS =
  import.meta.env.VITE_I18N_LOG_MISSING_TRANSLATIONS ?? 'false';
